var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nftInfo"}},[(_vm.type === 'medium')?_c('MediumView'):(_vm.type === 'small')?_c('SmallView'):(_vm.type === 'mini')?_c('MiniView'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }